import { FormattedMessage as FM, useIntl } from "react-intl";

import { ACTIVE_FIELD } from "../constants";

function ListItemTags({ config, item }) {
  const intl = useIntl();
  const tags = (config.tagFields || []).map((name) => {
    const field = config.fields.find((option) => option.name === name);
    const option = field.options.find((entry) => entry.value === item[name]);
    return option ? option.label : null;
  });
  const inactive = item[ACTIVE_FIELD] === false;
  if (!tags.some(Boolean) && !inactive) return null;
  return (
    <span className="mt-1 flex flex-wrap gap-1">
      {tags.filter(Boolean).map((label) => (
        <span
          key={label}
          className="rounded bg-neutral-100 px-1.5 py-0.5 text-[11px] font-medium text-neutral-600"
        >
          {intl.formatMessage({ id: label })}
        </span>
      ))}
      {inactive && (
        <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-900">
          <FM id="melhous.dash.list.inactive" />
        </span>
      )}
    </span>
  );
}

export default ListItemTags;
